import { useFeatureFlagsQuery } from '../useFeatureFlagsQuery';
export const useFeatureFlags = () => {
    const { data } = useFeatureFlagsQuery();
    return data || {};
};
